"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _FlexRow = require("../../layout/flex/FlexRow");
var _StyledIcon = require("../../media/icon/StyledIcon");
var _ContextMenu = _interopRequireDefault(require("../../navigation/ContextMenu"));
var _jsxRuntime = require("react/jsx-runtime");
var DraggableContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "DraggableContainer__DraggableContainerWrapper",
  componentId: "sc-tpda6u-0"
})(["background-color:", ";border-radius:4px;padding:6px 12px;cursor:grab;height:", ";"], _tokens.default.sky.ref.color.coolneutral['900'], _tokens.default.sky.sys.spacing[1400]);
var DraggableContainer = function DraggableContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DraggableContainerWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
      gap: 'm',
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledIcon.StyledIcon, {
        icon: 'drag',
        size: 'l',
        changeOnHover: true
      }), children]
    })
  });
};
DraggableContainer.ContextMenu = _ContextMenu.default;
var _default = exports.default = DraggableContainer;